import React from "react";
import PropTypes from "prop-types";

import {
  getDisplayMessageForQueryError,
  isSessionErrorMessage,
} from "helpers/authenticationErrors";

import SecondaryButton from "../Button/SecondaryButton";
import Icon from "../Icon/Icon";

import styles from "./QueryErrorPanel.module.scss";

const QueryErrorPanel = ({
  message = "Something went wrong. Please try again.",
  onRetry,
  className = "",
}) => {
  const isSessionError = isSessionErrorMessage(message);

  if (isSessionError) {
    return null;
  }

  const displayMessage = getDisplayMessageForQueryError(message);

  return (
    <div className={`${styles.panel} ${className}`}>
      <p className={styles.message}>{displayMessage}</p>
      {!isSessionError && onRetry ? (
        <SecondaryButton
          type="button"
          onClick={onRetry}
          startIcon={<Icon name="refresh" fontSize="small" />}
        >
          Retry
        </SecondaryButton>
      ) : null}
    </div>
  );
};

QueryErrorPanel.propTypes = {
  message: PropTypes.string,
  onRetry: PropTypes.func,
  className: PropTypes.string,
};

export default QueryErrorPanel;
